import { atom } from 'recoil';

import {
  CourtesyAssetData,
  CourtesyContent,
} from '@shared/api/courtesyAsset/courtesyAsset.interface';

export const courtesyMessageAtom = atom<string[] | null>({
  key: 'courtesyMessageAtom',
  default: null,
});

//* 선택된 courtesyAsset의 Id를 저장함
export const courtesyAssetAtom = atom<CourtesyAssetData | null>({
  key: 'courtesyAssetAtom',
  default: null,
});

//* 선택된 courtesyContent 자체를 저장함
export const courtesyContentAtom = atom<CourtesyContent | null>({
  key: 'courtesyContentAtom',
  default: null,
});

//* 수정한 courtesyContentString
export const courtesyContentStringAtom = atom<string | null>({
  key: 'courtesyContentStringAtom',
  default: null,
});

//* 고인명 표시 여부 토글
export const useDeceasedNameAtom = atom<boolean>({
  key: 'useDeceasedNameAtom',
  default: false,
});

//* 미리보기 이미지 위에서 조절한 본문 글씨 크기 증감(px)
export const courtesyTextFontDeltaAtom = atom<number>({
  key: 'courtesyTextFontDeltaAtom',
  default: 0,
});

//* 미리보기 이미지 위에서 조절한 본문 세로 위치 증감(px)
export const courtesyTextOffsetYAtom = atom<number>({
  key: 'courtesyTextOffsetYAtom',
  default: 0,
});

//* 미리보기에서 "글 수정하러 가기"를 누른 신호(증가할 때마다 본문 textarea로 이동·포커스)
export const courtesyEditRequestAtom = atom<number>({
  key: 'courtesyEditRequestAtom',
  default: 0,
});
